import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {UtilService} from "../../shared/util.service";
import {NetworkService} from "../network.service";
import {MatDialog} from "@angular/material/dialog";
import {NestedTreeControl} from "@angular/cdk/tree";
import {MatTreeNestedDataSource} from "@angular/material/tree";
import {DeviceDialogComponent} from "./device-dialog/device-dialog.component";
import {NodeModel} from "../../model/node.model";


@Component({
    selector: 'app-network-edit',
    templateUrl: './network-edit.component.html',
    styleUrls: ['./network-edit.component.scss'],
    standalone: false
})
export class NetworkEditComponent implements OnInit {
  levels = new Map<NodeModel, number>();
  treeControl: NestedTreeControl<NodeModel>;

  rootNode:NodeModel = null;

  dataSource: MatTreeNestedDataSource<NodeModel>;

  companies = [];
  counts: any = {
    datalogger: 0,
    meter: 0
  }
  title = null;

  options = {
    company: null
  };

  company:any = null;
  treeLoaded = false;

  constructor(
    private service: NetworkService,
    private route: ActivatedRoute,
    private router: Router,
    private util: UtilService,
    private dialog: MatDialog,

  ) {
  }

  ngOnInit(): void {
    this.fetchCompanies();
    this.initPage();
  }

  initPage() {
    this.route.params.subscribe((params:Params) => {
      let id = params['id'] ? params['id'] : null;
      if (!id) {
        return this.router.navigate(['/networks']);
      } else {
        this.fetchCompany(id);
      }
    })
  }

  initTree() {
    this.treeControl = new NestedTreeControl<NodeModel>(this.getChildren);
    this.dataSource = new MatTreeNestedDataSource();
    this.dataSource.data = [this.rootNode];
    this.treeControl.dataNodes = [this.rootNode];
    this.treeControl.expandAll();
    this.treeLoaded = true;
    this.updateDeviceCount()
  }

  getChildren = (node: NodeModel) => node.children;

  hasChildren = (index: number, node: NodeModel) => {
    return node.children.value.length > 0;
  };

  fetchCompanies() {
    this.service.getCompaniesSelectable().subscribe((resp:any) => {
      if (resp && resp.length) {
        this.companies = resp;
      }
    });
  }

  fetchCompany(id) {
    if (id === "new") {
      this.title = "Új hálózat";
      return;
    }
    this.options.company = id;

    this.service.getCompanyData(id).subscribe((resp:any) => {
      if (resp && resp.id) {
        this.company = resp;
        this.title = this.company.name;
        this.rootNode = new NodeModel(resp);
        this.initTree();
      }
    });
  }

  getParent(node, treeNode): NodeModel {
    let parent = null;
    if (treeNode.children && treeNode.children.value.length) {
      treeNode.children.value.forEach(child => {
        if (child.id === node.id) {
          parent = treeNode
        }
      });

      treeNode.children.value.forEach(child => {
        if (child.children && child.children.value.length && !parent) {
          parent = this.getParent(node, child);
        }
      })
    }
    return parent;
  }

  isNodeInTree(node) {
    let parent = this.getParent(node, this.dataSource.data[0]);
    if (parent && parent instanceof NodeModel) {
      let idx = parent.children.value.findIndex(i => +i.id === +node.id);
      return idx > -1 ? parent.children.value[idx] : false;
    }
    return false;
  }

  extractMeterFromDialogResult(result: any) {
    return new NodeModel({
      id: result.id,
      name: result.name,
      type: result.type ? result.type.name : null,
      typeID: result.type? result.type.id : null,
    })
  }

  extractSiteFromDialogResult(result:any) {
    return new NodeModel({
      id: result.siteid,
      name: result.site,
      postalCode: result.site,
      devices: [result]
    })
  }

  onNewMeterBtnClick(node?: NodeModel, isEdit = false) {
    let details = {
      company: null,
      companyid: null,
      siteid: null,
      parent: null
    };
    if (node) {
      if (node.isSite()) {
        details.siteid = node.id;

        let company = this.getParent(node, this.rootNode);
        if (company) {
          details.companyid = company.id;
          details.company = company.name;
        }

      } else if (node.isCompany()) {
        details.companyid = node.id;
        details.company = node.name;
      } else if (node.isDatalogger()) {
        details.company = node.company;
        details.companyid = node.companyid;
        details.siteid = node.siteid;
        details.parent = node.id;
      }
    } else {
      details.companyid = this.company.id;
      details.company = this.company.name;
    }

    this.openDialog(details, false, node)

  }

  replaceNodeInTree(node) {
    let parent = this.getParent(node, this.dataSource.data[0]);
    if (parent && parent instanceof NodeModel) {
      let idx = parent.children.value.findIndex(i => +i.id === +node.id);
      parent.children.value[idx] = node;
      this.treeControl.expand(parent);
      this.treeControl.expand(node);
    } else {
      console.log("not able to replace node in tree", node);
    }
  }

  removeNode(node) {
    const parent = this.getParent(node, this.dataSource.data[0]) as NodeModel;
    if (parent) {
      let idx = parent.children.value.findIndex(i => +i.id === +node.id)
      if (idx > -1) {
        parent.children.value.splice(idx, 1);
        this.refreshTree()
      }
    }
  }

  openDialog(node, isEdit = false, parent?: NodeModel) {
    const dialogRef = this.dialog.open(DeviceDialogComponent, {
      data: {
        item: Object.assign(new NodeModel(), node),
        isEdit: isEdit
      },
      minWidth: '300px',
      maxWidth: '500px'
    });

    dialogRef.afterClosed().subscribe( (result: any) => {
      if (result) {
        if (result instanceof NodeModel) {
          if (isEdit) {
            this.replaceNodeInTree(result);
          } else {
            // Meter device, find datalogger in tree and add it below
            if (result.parent) {
              let deviceNode = this.isNodeInTree({id: result.parent});
              if (deviceNode) {
                deviceNode.addChild(result)
              } else {
                return this.service.notiService.open("Can not find parent Node in tree with id " + result.parent);
              }
            } else {
              // new node, check if site exist and add node
              let siteNode = this.isNodeInTree({id: result.siteid});
              if (siteNode) {
                siteNode.addChild(result)
              } else {
                // Add the new site+meter to a child company (if found one)
                if (parent) {
                  parent.addChild(this.extractSiteFromDialogResult(result));
                } else {
                  this.rootNode.addChild(this.extractSiteFromDialogResult(result));
                }
              }
            }
          }
        } else if(result.delete) {
          this.removeNode(node);
        }


        this.refreshTree();
      }
    });
  }

  refreshTree(){
    let _data = this.dataSource.data;
    this.dataSource.data = null;
    this.dataSource.data = _data;
    this.updateDeviceCount();
  }

  countDevices(node, runningCount = {datalogger: 0, meter: 0}) {
    if (node.children && node.children.value.length) {
      node.children.value.forEach(child => {
        if (child.isDatalogger()) {
          runningCount.datalogger += 1;
        } else if (child.isMeter()) {
          runningCount.meter += 1;
        }
      });

      node.children.value.forEach(child => {
        if (child.children && child.children.value.length) {
          runningCount = this.countDevices(child, runningCount);
        }
      })
    }
    return runningCount;
  }

  updateDeviceCount() {
    this.counts = {
      datalogger: 0,
      meter: 0
    }
    const data = this.dataSource.data[0];
    if (data) {
      this.counts = this.countDevices(data)
    }
  }
}
